import React from "react"

export const PRODUCT_FILE_DOWNLOAD_URL =
  "https://app.ma.scrmtech.com/resources/ResourcePc/resourcePcInfo?pf_uid=19697_1864&pf_type=3&id=21153"

export const CONSULT_DETAIL =
  "通过购买 PingCAP 企业订阅，商业用户可持续获得企业版产品演进带来的创新与能力提升，同时享有产品故障的及时诊断与修复和来自 PingCAP 产品支持专家的专业指导与支持。"

export const ENTERPRISE_DESCRIPTION = [
  {
    h2: "PingCAP 企业订阅用户权益",
    p: "购买 PingCAP 企业订阅的用户可以享有以下权益：",
    ul: [
      {
        className: "blueCircle",
        data: [
          "持续交付：可获得约定交付版本内和官方支持周期版本内的持续交付的数据库补丁、漏洞修复、产品更新、大小版本升级的软件介质。",
          "技术支持：全天候、不限次数的工单支持、电话响应，包括故障远程支持，专业技术指导，涉及多供应商的技术问题协查等。",
        ],
      },
    ],
  },
  {
    id: "subscriptionServiceSystem",
    h2: "PingCAP 企业订阅产品服务体系",
    table: {
      header: ["服务类别", "服务描述"],
      body: [
        [
          "产品支持",
          "产品及使用问题的远程工单在线支持及电话响应。<br />产品，产品升级包，勘误，补丁的介质下载。<br />产品安全相关预警通知。",
        ],
        ["远程故障响应", "对各等级故障提供最高 7*24 的远程故障响应支持"],
        ["远程技术指导", "提供针对数据库使用、操作、工具使用等内容的指导和建议"],
      ],
    },
  },
  {
    h2: "PingCAP 企业订阅服务规则",
    ul: [
      {
        className: "blueCircle",
        data: [
          "PingCAP 企业订阅是按年为单位，根据集群规模 vCPU 用量计量的收费产品交付和服务模式。",
          "PingCAP 企业订阅将企业级产品组件和商业服务捆绑在一起不可分割。",
          "PingCAP 企业订阅包含和社区版一样的产品内核及社区版所不具备的特有的安全/可用性/数据分析/Cloud 相关组件。",
          "PingCAP 企业订阅中的 TiDB 的数据库基础核心功能严格保持与社区版一致。",
          "PingCAP 企业订阅有效期内，包含所有订阅覆盖的大小版本的产品获取和服务支持。",
          //"PingCAP 企业订阅包含社区版用户的所有服务权益，并且能够获得独有的企业用户服务，主要包括以下内容：",
          (
            <>
              PingCAP 企业订阅包含社区版用户的所有服务权益，并且能够获得独有的企业用户服务，主要包括以下内容：
              <ul>
                <li>通过在线工单系统，进行问题/故障的工单创建，处理和跟踪。</li>
                <li>通过在线工单系统，获得在线的 PingCAP 支持工程师提供的 TiDB 数据库相关技术支持和使用指导。</li>
                <li>在紧急问题上，可供选择的技术支持服务升级联系通道。</li>
                <li>已购买 PingCAP 企业订阅且在有效订阅期内的用户允许通过购买 PingCAP 原厂专家咨询服务以便于获得服务范围更广的支持，如现场架构咨询、应用适配、知识传递、深度巡检、扩容变更支持、多方故障协查、故障根源分析、规范/手册定制化、应急故障现场处置、重大时期内的现场保障等。</li>
              </ul>
            </>
          ),
        ],
      },
    ],
  },
  {
    id: "expertService",
    h2: "专家咨询服务",
    p:
      "已购买和获得 PingCAP 企业订阅许可且在有效订阅期内的用户，可以通过购买 PingCAP 原厂专家咨询服务（以人天计）以便于获得服务范围更广的支持。我们的专家服务包括：",
    ul: [
      {
        className: "blueCircle",
        data: [
          "现场架构咨询",
          "应用适配",
          "知识传递",
          "深度巡检",
          "扩容变更支持",
          "多方故障协查",
          "故障根源分析",
          "规范/手册定制化",
          "应急故障现场处置",
          "重大时期内的现场保障等",
        ],
      },
    ],
  },
]

export const COMMUNITY_LINK_LIST = [
  {
    name: "快速上手指南",
    link: "https://docs.pingcap.com/zh/tidb/stable/quick-start-with-tidb",
  },
  {
    name: "查看 TiDB 文档",
    link: "https://docs.pingcap.com/zh/tidb/stable",
  },
  {
    name: "前往问答社区（AskTUG）提问",
    link: "https://asktug.com",
  },
  {
    name: "了解社区",
    link: "https://tidb.net",
  },
]

export const SLACK_LINK =
  "https://slack.tidb.io/invite?team=tidb-community&channel=everyone"
export const EMAIL_LINK = "mailto:community@tidb.io"
